var PDP_object_compare_table_slider = document.querySelector('.PDP_object_compare_table_slider');

if (PDP_object_compare_table_slider) {
    new Swiper('.PDP_object_compare_table_slider', {
        loop: false,
        grabCursor: false,
        spaceBetween: 0,
        slidesPerGroup: 1,
        slidesPerView: 2,
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        scrollbar: {
            el: ".swiper-scrollbar-table"
        },
        observer: true,
        observeParents: true,
        breakpoints: {
            0: {
                slidesPerView: "auto"
            },
            750: {
                slidesPerView: 2
            },
            990: {
            },
            1200: {
            },
            1440: {
            }
        }
    })
}